<template>
  <div class="wrapper">
    <div class="circle">
      <div class="circle-text">
        <div class="circle-title">Missing</div>
        <div class="circle-ctx">The page you were looking for could not be found.</div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'errorPage',
    data () {
      return {

      }
    },
    created () {

    },
    methods: {

    }
  }
</script>

<style lang="stylus" scoped>
  @import "~@/assets/css/public.styl"
  .wrapper
    position relative;min-width 1000px;width: 100%;min-height 100vh;background-color #020202
    .circle
      absoCenter();width: 500px;height: 500px;border 20px solid #ff9700;border-radius 50%
      .circle-text
        absoCenter();width 100%;height 60px;
        .circle-title
          text-align center;font-size 24px;font-weight bold;line-height 30px;color #dcaa2e
        .circle-ctx
          text-align center;font-size 16px;line-height 30px;color #5c5e60
</style>
